// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAreaChartOutlinedSvg from "@fishx/icons-svg/es/asn/PAreaChartOutlined";
import FishxIcon from '../components/FishxIcon';

var PAreaChartOutlined = function PAreaChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAreaChartOutlinedSvg
  }));
};

PAreaChartOutlined.displayName = 'PAreaChartOutlined';
export default React.forwardRef(PAreaChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAreaChartOutlined.js
// module id = 3212
// module chunks = 0